// src/config/environment.ts

// Determine the application environment based on VITE_APP_ENV
// Default to 'production' if not explicitly set
export const APP_ENV = import.meta.env.VITE_APP_ENV || 'production';

// Log the detected environment for debugging purposes
if (!import.meta.env.PROD) {
  console.log(`🌐 ${APP_ENV.charAt(0).toUpperCase() + APP_ENV.slice(1)} environment detected`);
}

// Get Supabase configuration based on environment
export const getSupabaseConfig = () => {
  if (APP_ENV === 'staging' || APP_ENV === 'homolog') {
    return {
      url: import.meta.env.VITE_SUPABASE_URL_HOMOLOG || import.meta.env.VITE_SUPABASE_URL,
      anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY_HOMOLOG || import.meta.env.VITE_SUPABASE_ANON_KEY,
    };
  }
  
  return {
    url: import.meta.env.VITE_SUPABASE_URL_PROD || import.meta.env.VITE_SUPABASE_URL,
    anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY_PROD || import.meta.env.VITE_SUPABASE_ANON_KEY,
  };
};

// Function to get the complete edge function URL
export const getEdgeFunctionUrl = (functionName: string) => {
  const config = getSupabaseConfig();
  return `${config.url}/functions/v1/${functionName}`;
};

// Function to get the current environment name for logging
export const getEnvironmentName = () => {
  return APP_ENV === 'staging' || APP_ENV === 'homolog' ? 'HOMOLOG' : 'PRODUCTION';
};